/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 * @author Maxim Fedorov
 * @author Yakov.Gushchin
 * @version 1.0.5
 * @since 1.0.0
 */

import { ThStyled, TrStyled } from './styled/CalendarTableStyled';

interface ITable {
    children?: any;
    className?: any;
    colSpan?: any;
    onClick?: any;
    onMouseDown?: any;
    style?: any;
}

export const Tr = (props: ITable) => (
    <TrStyled className={props.className} style={props.style} onClick={props.onClick}>
        {props.children}
    </TrStyled>
);

export const Th = (props: ITable) => (
    <ThStyled className={props.className} style={props.style} onClick={props.onClick}
              onMouseDown={props.onMouseDown}>
        {props.children}
    </ThStyled>
);

export const TBody = (props: ITable) => (
    <div className={props.className} style={props.style}>
        {props.children}
    </div>
);

export const THead = (props: ITable) => (
    <div className={props.className} style={props.style}>
        {props.children}
    </div>
);

export const CalendarTable = (props: ITable) => (
    <div className={props.className} style={props.style}>
        {props.children}
    </div>
);
